import _styled from "styled-components";
var _excluded = ["css", "style", "text", "type", "textColor", "backgroundColor"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from "../../styleguide";
export var LabelWrapper = styled.div.withConfig({
  displayName: "Label__LabelWrapper",
  componentId: "sc-ggan5t-0"
})(["width:", ";font-size:", ";text-align:center;border-radius:2px;padding:", ";color:", ";background-color:", ";line-height:", ";", ";"], function (props) {
  return props.type === 'short' ? '14px' : 'auto';
}, function (props) {
  return props.type === 'text' ? '17px' : '12px';
}, function (props) {
  return props.type === 'short' ? '' : '0px 3px 0px 3px';
}, function (props) {
  if (props.textColor) return props.textColor;
  if (props.type === 'text') return colors.grey500;
  return colors.white100;
}, function (props) {
  if (props.backgroundColor) return props.backgroundColor;
  if (props.type === 'text') return '';
  return colors.grey500;
}, function (props) {
  if (props.type === 'text') return '26px';
  if (props.type === 'badge') return '20px';
  return '14px';
}, function (props) {
  return props.css;
});

var _StyledLabelWrapper = styled(LabelWrapper).withConfig({
  displayName: "Label___StyledLabelWrapper",
  componentId: "sc-ggan5t-1"
})(["", ""], function (p) {
  return p.$_css;
});

var types = process.env.NODE_ENV !== "production" ? ['short', 'badge', 'text'] : {};

var Label = function Label(_ref) {
  var css = _ref.css,
      style = _ref.style,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'badge' : _ref$type,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_StyledLabelWrapper, _extends({
    style: style,
    type: type,
    textColor: textColor,
    backgroundColor: backgroundColor
  }, other, {
    $_css: css
  }), type === 'short' ? text[0].toUpperCase() : text);
};

Label.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Overriding css object
   */
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /**
   * Overriding style object
   */
  style: PropTypes.object,

  /**
   * The text in the label
   */
  text: PropTypes.string.isRequired,

  /**
   * The type of the label which affects its styling
   */
  type: PropTypes.oneOf(types),

  /**
   * The label text color
   */
  textColor: PropTypes.string,

  /**
   * The label background color
   */
  backgroundColor: PropTypes.string
} : {};
export default Label;
//# sourceMappingURL=Label.js.map